import { __awaiter, __extends, __generator } from "tslib";
import { query as getAppSettingsQuery } from '../../graphql/getAppSettings.graphql';
import { BaseApi } from '../BaseApi';
import { GraphQLOperations, RemoteSourceTypes } from '../constants';
var AppSettingsApi = /** @class */ (function (_super) {
    __extends(AppSettingsApi, _super);
    function AppSettingsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AppSettingsApi.prototype.fetchWidgetSettings = function (variables) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetch({
                            variables: variables,
                            query: getAppSettingsQuery,
                            operationName: GraphQLOperations.GetAppSettings,
                        }, RemoteSourceTypes.ScalaReadOnly)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.appSettings];
                }
            });
        });
    };
    return AppSettingsApi;
}(BaseApi));
export { AppSettingsApi };
//# sourceMappingURL=AppSettingsApi.js.map